import { Editor } from '@tiptap/react';
import { fromEditorHtml, toEditorHtml } from './placeholderMarkup';
import { DEFAULT_RICH_TEXT_CONFIG, richTextExtensions, type RichTextConfig } from './richTextExtensions';

const normalise = (html: string): string => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
    const blanks: Node[] = [];
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
        if (!node.textContent?.trim()) blanks.push(node);
    }
    blanks.forEach((node) => node.parentNode?.removeChild(node));
    doc.querySelectorAll('li > p:only-child').forEach((paragraph) => paragraph.replaceWith(...Array.from(paragraph.childNodes)));
    return doc.body.innerHTML;
};

export function canRenderAsRichText(html: string, config: RichTextConfig = DEFAULT_RICH_TEXT_CONFIG): boolean {
    if (!html.trim()) return true;
    const probe = new Editor({ extensions: richTextExtensions(config), content: toEditorHtml(html, config) });
    try {
        return normalise(fromEditorHtml(probe.getHTML(), config)) === normalise(html);
    } finally {
        probe.destroy();
    }
}
